import { Helmet } from "react-helmet-async";

const SEO = () => {
  const siteUrl = "https://sahajmaniya.vercel.app/";
  const previewImage = `${siteUrl}favicon-logo.png`;

  return (
    <Helmet>
      <title>Sahaj Maniya | Portfolio</title>
      <meta name="description" content="Welcome to Sahaj Maniya's portfolio. Explore my projects, skills, and experiences in frontend development and UI/UX design." />
      <meta name="keywords" content="Sahaj Maniya, Portfolio, Frontend Developer, UI/UX Designer, React, JavaScript, TailwindCSS" />
      <meta name="author" content="Sahaj Maniya" />
      <link rel="canonical" href={siteUrl} />
      
      {/* Open Graph Meta Tags for Social Media */}
      <meta property="og:title" content="Sahaj Maniya | Portfolio" />
      <meta property="og:description" content="Explore my projects, skills, and experiences in frontend development and UI/UX design." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:image" content={previewImage} />
      <meta property="og:image:alt" content="Sahaj Maniya Portfolio Preview" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Sahaj Maniya | Portfolio" />
      <meta name="twitter:description" content="Explore my projects, skills, and experiences in frontend development and UI/UX design." />
      <meta name="twitter:image" content={previewImage} />

      {/* Social Media Profiles */}
      <link rel="me" href="https://www.instagram.com/sahajmaniya_/" />
      <link rel="me" href="https://www.linkedin.com/in/sahajmaniya/" />
      <link rel="me" href="https://www.facebook.com/profile.php?id=100075120465471&mibextid=ZbWKwL" />
    </Helmet>
  );
};

export default SEO;
